import { render } from "./InteldeskHome.vue?vue&type=template&id=90d9ed3e&scoped=true"
import script from "./InteldeskHome.vue?vue&type=script&lang=js"
export * from "./InteldeskHome.vue?vue&type=script&lang=js"

import "./InteldeskHome.vue?vue&type=style&index=0&id=90d9ed3e&scoped=true&lang=scss"

import exportComponent from "/Users/leopons/Desktop/1_bm_dev/bubblemaps-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d9ed3e"]])

export default __exports__